@use '@fpsm/cxy-scss' as cxy;

.matchupCard {
  width: 100%;
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
  border-radius: var(--cxy-spacing-xxsm);
  overflow: hidden;
  color: var(--cxy-color-text-default-body);
  font-family: var(--font-family-base);
  box-sizing: border-box;
}

.header {
  display: grid;
  grid-template-columns: minmax(250px, 3fr) repeat(3, minmax(auto, 1fr));
  grid-column-gap: var(--cxy-spacing-xxxsm);
  background-color: var(--cxy-color-surface-primary-default-subtle);
  align-items: center;
  padding: 0 var(--cxy-spacing-xsm);
}

.matchupCard:has(.soccerTeamRow) .header {
  grid-template-columns: minmax(320px, 3fr) repeat(3, minmax(90px, 1fr));
}

.eventInfo {
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  color: var(--cxy-color-text-default-body);
}

.marketGrid {
  display: grid;
  grid-template-columns: minmax(250px, 3fr) repeat(3, minmax(auto, 1fr));
  grid-column-gap: var(--cxy-spacing-xxxsm);
  grid-row-gap: var(--cxy-spacing-xxxsm);
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
  width: 100%;
  padding: 0 var(--cxy-spacing-xxxsm) var(--cxy-spacing-xsm) var(--cxy-spacing-xxxsm);

  @media (--cxy-desktop) {
    padding: var(--cxy-spacing-xsm);
  }
}

.marketGrid:has(.soccerTeamRow) {
  grid-template-columns: minmax(320px, 3fr) repeat(3, minmax(90px, 1fr));
}

.marketLabel {
  text-align: center;
  font-size: var(--cxy-fontSize-xs);
  font-weight: var(--cxy-fontWeight-semiBold);
  padding: var(--cxy-spacing-3) var(--cxy-spacing-xsm);
}

.teamColumn {
  display: flex;
  align-items: center;
}

.teamContent {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-xxsm);
  width: 100%;
}

.teamRow {
  display: contents;

  > div {
    background-color: var(--cxy-color-surface-success-default-subtle-hover);
  }
}

.teamRow:last-child > div {
  border-bottom: none;
}

.teamBadge {
  inline-size: 22px;
  block-size: 22px;
  object-fit: contain;
}

.teamName {
  font-size: var(--cxy-fontSize-m);
  font-weight: var(--cxy-fontWeight-medium);
  color: var(--cxy-color-text-default-body);
  word-break: break-word;
  line-height: 1.2;
}

.betCell {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.betCell button {
  width: 100%;
  max-width: none;
}

.soccerTeamRow .betCell {
  padding-inline: var(--cxy-spacing-xxxsm);
}

.soccerTeamRow .betCell button {
  font-size: var(--cxy-fontSize-s);
}

.soccerBetButton {
  min-width: 75px !important;
}

.noBet {
  font-size: var(--cxy-fontSize-m);
  color: var(--cxy-color-content-subtle);
}

.soccerTeamRow {
  display: contents;
}

.soccerTeamRow > div {
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
}

.soccerStackedTeams {
  @include cxy.stack(var(--cxy-spacing-xxsm));
  width: 100%;
}

.soccerStackedTeam {
  display: flex;
  align-items: center;
  gap: var(--cxy-spacing-xxsm);
  min-width: 0;
  width: 100%;
  flex: 1;
}

.matchupFooter {
  background-color: var(--cxy-color-surface-primary-default-subtle);
  padding: var(--cxy-spacing-3) var(--cxy-spacing-xsm);
  text-align: right;
  border-top: none;
}

.matchupAnalysisLink {
  color: var(--cxy-color-text-default-body);
  text-decoration: none;
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  display: inline-flex;
  align-items: center;
  gap: var(--cxy-spacing-xxxsm);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}
.matchupAnalysisLink:hover {
  text-decoration: underline;
}

.arrow {
  font-size: var(--cxy-fontSize-m);
}

.eventTime {
  font-size: var(--cxy-fontSize-s);
  font-weight: var(--cxy-fontWeight-semiBold);
  color: var(--cxy-color-text-default-body);
}

.mobileHeader {
  background-color: var(--cxy-color-surface-primary-default-subtle);
  padding: var(--cxy-spacing-xsm);
}

.mobileMarketLabels {
  display: grid;
  grid-template-columns: 50px repeat(3, 1fr);
  grid-column-gap: var(--cxy-spacing-xxxsm);
  background-color: var(--cxy-color-surface-success-default-subtle-hover);
  padding: 0 var(--cxy-spacing-xxxsm);

  > div {
    padding-bottom: var(--cxy-spacing-xxxsm);
  }
}

.matchupCard:has(.soccerTeamRow) .mobileMarketLabels {
  grid-template-columns: 90px repeat(3, 1fr);
}

@media (--cxy-below-desktop) {
  .eventInfo {
    font-size: var(--cxy-fontSize-xs);
  }
  .marketLabel {
    padding: var(--cxy-spacing-xxsm);
    font-size: 10px;
  }
  .marketGrid {
    grid-template-columns: 50px repeat(3, 1fr);
  }
  .marketGrid:has(.soccerTeamRow) {
    grid-template-columns: 90px repeat(3, 1fr);
  }
  .teamContent {
    flex-direction: column;
    gap: var(--cxy-spacing-xxxsm);
    text-align: center;
  }
  .teamBadge {
    inline-size: 20px;
    block-size: 20px;
  }
  .teamName {
    font-size: var(--cxy-fontSize-xs);
    word-break: break-word;
    line-height: 1.2;
  }
  .betCell button {
    max-width: 120px;
    min-width: 80px;
  }
  .soccerStackedTeam {
    gap: var(--cxy-spacing-xxxsm);
    padding-left: var(--cxy-spacing-xxsm);
  }
  .soccerStackedTeam span[data-radix-avatar-root] {
    display: none;
  }
}

/* Gazzetta theme overrides */
[data-fpsm-theme='gazzetta'] {
  .matchupCard {
    border: 1px solid var(--cxy-color-surface-primary-default-subtle);
  }
}
